import React from "react"
import Stack from "@UILibrary/Stack"
import Button from "@UILibrary/Button"
import classNames from "classnames";

import "./pagination.css"

type PaginationProps = {
  count: number;
  current: number;
  perPage: number;
  onPaginate: (pageNumber: number) => void;
  size?: "small" | "medium" | "large",
  className?: string;
}

const baseClass = "wb-pagination"

const Pagination = ({
  count,
  current,
  perPage,
  onPaginate,
  size = "small",
  className,
}: PaginationProps) => {

  const pages = Math.ceil(count / perPage);

  if (count <= perPage) return null;
  
  const handlePrevious = () => {
    if (current > 1){
      onPaginate(current - 1);
    }
  }

  const handleNext = () => {
    if (current < pages){
      onPaginate(current + 1);
    }
  }
  
  return (
    <Stack
      className={className}
      inline
      padding={size.charAt(0)}
      spacing={size.charAt(0)}
      alignItems="center"
      justifyContent="center"
      horizontal
    >
      <Button
        className={classNames({ [`${baseClass}__control-disabled`]: current === 1 })}
        size={size}
        textOnly
        textOnlyVariant={current > 1 ? "link" : ""}
        onClick={handlePrevious}>Previous</Button>
      <Button size={size} textOnly textOnlyVariant="link">{current}</Button>
      <Button
        className={classNames({ [`${baseClass}__control-disabled`]: current === pages })}
        size={size}
        textOnly
        textOnlyVariant={current < pages ? "link" : ""}
        onClick={handleNext}>Next</Button>
    </Stack>
  )
}

export { Pagination }
